import { render, staticRenderFns } from "./NotificationManager.vue?vue&type=template&id=b534654e&scoped=true&"
import script from "./NotificationManager.vue?vue&type=script&lang=js&"
export * from "./NotificationManager.vue?vue&type=script&lang=js&"
import style0 from "./NotificationManager.vue?vue&type=style&index=0&id=b534654e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b534654e",
  null
  
)

export default component.exports